<div class="register-cta-container container">
  <p class="h3 header-title">Crie agora o seu evento!</p>
  <div class="container-text">
    <div class="container-col-text">
      <h1>{{ "call-to-action-register-home.title" | translate }}</h1>
      <p>{{ "call-to-action-register-home.description" | translate }}</p>
      @if (isLoggedIn) {
        <app-button styleType="secondary" style="height: 40px; font-size: 1em" (click)="goToCreateEvent()">
          {{ "call-to-action-register-home.button-create-event" | translate }}
        </app-button>
      } @else {
        <app-button styleType="secondary" style="height: 40px; font-size: 1em" (click)="openModalSignUp()">
          {{ "call-to-action-register-home.button-register" | translate }}
        </app-button>
      }
    </div>
    <div class="container-col-image">
      <img
        src="./../../../assets/images/home/homem-notebook-yes-seven.png"
        alt="Homem de oculos camisa de botão cinza segurando notebook" />
    </div>
  </div>
  <div class="background-gray"></div>
</div>
